import { useState } from "react";
import { countryFlagUrl } from "@/utils/countryFlag.js";
import "./country-flag.css";

/**
 * Renders a country flag from its ISO code, with emoji fallback.
 */
export default function CountryFlag({ country, size = "md", className = "" }) {
    const [imageFailed, setImageFailed] = useState(false);

    if (!country) {
        return null;
    }

    const isoCode = country.isoCode;
    const src = countryFlagUrl(isoCode);
    const alt = country.name ? `Drapeau ${country.name}` : "Drapeau";
    const sizeClass = `country-flag--${size}`;

    if (src && !imageFailed) {
        return (
            <img
                src={src}
                alt={alt}
                className={`country-flag ${sizeClass}${className ? ` ${className}` : ""}`}
                loading="lazy"
                decoding="async"
                onError={() => setImageFailed(true)}
            />
        );
    }

    if (country.flagEmoji) {
        return (
            <span
                className={`country-flag-emoji ${sizeClass}${className ? ` ${className}` : ""}`}
                aria-hidden="true"
            >
                {country.flagEmoji}
            </span>
        );
    }

    return null;
}
